import { render, staticRenderFns } from "./FrameworkSwitcher2.vue?vue&type=template&id=4d802be1"
import script from "./FrameworkSwitcher2.vue?vue&type=script&lang=js"
export * from "./FrameworkSwitcher2.vue?vue&type=script&lang=js"
import style0 from "./FrameworkSwitcher2.vue?vue&type=style&index=0&id=4d802be1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports